import React from 'react';
import { createPortal } from 'react-dom';

/**
 * ModalPortal - A reusable modal wrapper that uses React Portal to render modals
 * at the document.body level, ensuring they appear above all page content.
 * 
 * This fixes z-index stacking context issues with PostcardHero stamps and other elements.
 */
const ModalPortal = ({ isOpen, onClose, children, maxWidth = '600px', maxHeight = '90vh' }) => {
  if (!isOpen) return null;

  const modalContent = (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999,
        padding: '20px',
        overflowY: 'auto'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: 'white',
          borderRadius: '20px',
          maxWidth: maxWidth,
          width: '100%',
          maxHeight: maxHeight,
          overflowY: 'auto',
          position: 'relative',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            border: 'none',
            fontSize: '24px',
            lineHeight: '1',
            color: '#141416',
            cursor: 'pointer',
            zIndex: 10
          }} 
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );

  // Render modal at document.body level, outside all stacking contexts
  return createPortal(modalContent, document.body);
};

export default ModalPortal;

